export default __webpack_public_path__ + "static/media/princetonnew.be589381.png";